enum LinkableTransmitterStepType {
  SelectType = 'SelectType',
  EnterDeviceId = 'EnterDeviceId',
  Confirm = 'Confirmation',
}

export default LinkableTransmitterStepType;
